export default __webpack_public_path__ + "static/media/legend_prequaternary_lithology.eed06894.png";